export const AllCookiesName = {
  token: "device_id",
  remember: "session_type",
  passwordReset: "temp_p_value",
  refreshToken: "device_r_key",
  accessToken: "user_token",
  AuthenticationToken: "temp_l_key",
  userName: "user_detail",
  useruid: "user_uid",
};
